/**
Author - Venkatesh Pullaganti 😃
Git - https://github.com/venkatesh1146
**/

import {createGlobalStyle} from 'styled-components';

export const ClientGlobalStyles = createGlobalStyle`
  .primary-title {
    font-family: 'Marcellus' !important;
    font-weight: 400;
    color: #000000;
  }
  

  // OLD styles
  ${
    '' /* .description1 {
    font-family: 'MavenPro' !important;
    font-size: 2rem;
  }

  .body-small {
    font-family: 'MavenPro' !important;
    font-size: 1.4rem;
  }

  .button-title {
    font-weight: 500;
    font-family: MavenPro;
    font-size: 1.6rem;
  }

  .caption {
    font-family: 'MavenPro' !important;
    font-size: 1.4rem;
    font-weight: 500;
  }

  .caption2 {
    font-family: 'MavenPro' !important;
    font-size: 1.125rem;
    font-weight: 500;
  }

  .form-input {
    font-size: 1.6rem;
    font-family: 'MavenPro' !important;
    font-weight: 500;
  } */
  }

  .description1 {
    font-family: ${(props) => props.theme.typography.fontFamily.primary} !important;
    font-size: ${(props) => props.theme.typography.fontSize.md};
  }

  .button-title {
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    font-size: ${(props) => props.theme.typography.fontSize.md};
  }

  .caption {
    font-family: ${(props) => props.theme.typography.fontFamily.primary} !important;
    font-size: ${(props) => props.theme.typography.fontSize.md};
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  }

  .caption2 {
    font-family: ${(props) => props.theme.typography.fontFamily.primary} !important;
    font-size: ${(props) => props.theme.typography.fontSize.sm};
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  }

  .form-input {
    font-size: ${(props) => props.theme.typography.fontSize.lg};
    font-family: ${(props) => props.theme.typography.fontFamily.primary} !important;
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
  }

  //NOTE: Client Web 3.0 Design [https://www.figma.com/design/QoQvA6kHBYKeeyJ6Jaoa7f/Client-Web-App-3.0?node-id=15824-11490&t=FnqIxBx6e926eIhX-4]
   /* Base styles */
  html {
    font-size: ${(props) => props.theme.baseUnit};
    box-sizing: border-box;
  }
  
  *, *:before, *:after {
    box-sizing: inherit;
  }
  
  body {
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    margin: 0;
    padding: 0;
    line-height: ${(props) => props.theme.typography.lineHeight.normal};
    color: ${(props) => props.theme.colors.text.primary};
    background-color: ${(props) => props.theme.colors.background.primary};
  }
  
  /* Typography Classes */
  
  /* Display and Headings */
  .display {
    font-family: ${(props) => props.theme.typography.styles.display.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.display.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.display.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.display.lineHeight};
    margin-bottom: ${(props) => props.theme.spacing.md};
  }
  
  .heading-1 {
    font-family: ${(props) => props.theme.typography.styles.heading[1].fontFamily};
    font-size: ${(props) => props.theme.typography.styles.heading[1].fontSize};
    font-weight: ${(props) => props.theme.typography.styles.heading[1].fontWeight};
    line-height: ${(props) => props.theme.typography.styles.heading[1].lineHeight};
    margin-bottom: ${(props) => props.theme.spacing.md};
  }
  
  .heading-2 {
    font-family: ${(props) => props.theme.typography.styles.heading[2].fontFamily};
    font-size: ${(props) => props.theme.typography.styles.heading[2].fontSize};
    font-weight: ${(props) => props.theme.typography.styles.heading[2].fontWeight};
    line-height: ${(props) => props.theme.typography.styles.heading[2].lineHeight};
    margin-bottom: ${(props) => props.theme.spacing.sm};
  }
  
  .heading-3 {
    font-family: ${(props) => props.theme.typography.styles.heading[3].fontFamily};
    font-size: ${(props) => props.theme.typography.styles.heading[3].fontSize};
    font-weight: ${(props) => props.theme.typography.styles.heading[3].fontWeight};
    line-height: ${(props) => props.theme.typography.styles.heading[3].lineHeight};
    margin-bottom: ${(props) => props.theme.spacing.sm};
  }
  
  /* Body Text */
  .body-large {
    font-family: ${(props) => props.theme.typography.styles.body.large.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.body.large.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.body.large.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.body.large.lineHeight};
  }
  
  .body-large-semibold {
    font-family: ${(props) => props.theme.typography.styles.body.largeSemibold.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.body.largeSemibold.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.body.largeSemibold.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.body.largeSemibold.lineHeight};
  }
  
  .body-medium {
    font-family: ${(props) => props.theme.typography.styles.body.medium.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.body.medium.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.body.medium.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.body.medium.lineHeight};
  }
  
  .body-regular {
    font-family: ${(props) => props.theme.typography.styles.body.regular.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.body.regular.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.body.regular.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.body.regular.lineHeight};
  }
  
  .body-small {
    font-family: ${(props) => props.theme.typography.styles.body.small.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.body.small.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.body.small.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.body.small.lineHeight};
  }
  
  .cta {
    font-family: ${(props) => props.theme.typography.styles.cta.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.cta.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.cta.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.cta.lineHeight};
    text-transform: ${(props) => props.theme.typography.styles.cta.textTransform};
  }
  
  .label {
    font-family: ${(props) => props.theme.typography.styles.label.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.label.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.label.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.label.lineHeight};
  }
  
  .express {
    font-family: ${(props) => props.theme.typography.styles.express.fontFamily};
    font-size: ${(props) => props.theme.typography.styles.express.fontSize};
    font-weight: ${(props) => props.theme.typography.styles.express.fontWeight};
    line-height: ${(props) => props.theme.typography.styles.express.lineHeight};
  }
  
 /* Color utility classes */
  .text-primary {
    color: ${(props) => props.theme.colors.brand.primary} !important;
  }
  
  .text-secondary {
    color: ${(props) => props.theme.colors.brand.secondary} !important;
  }
  
  .text-tertiary {
    color: ${(props) => props.theme.colors.brand.tertiary} !important;
  }
  
  .text-black {
    color: ${(props) => props.theme.colors.text.primary} !important;
  }
  
  .text-grey {
    color: ${(props) => props.theme.colors.text.secondary} !important;
  }
  
  .text-disabled {
    color: ${(props) => props.theme.colors.text.disabled} !important;
  }
  
  .text-error {
    color: ${(props) => props.theme.colors.feedback.error} !important;
  }
  
  .text-success {
    color: ${(props) => props.theme.colors.feedback.success} !important;
  }
  
  .bg-primary {
    background-color: ${(props) => props.theme.colors.brand.primary} !important;
  }
  
  .bg-secondary {
    background-color: ${(props) => props.theme.colors.brand.secondary} !important;
  }
  
  .bg-tertiary {
    background-color: ${(props) => props.theme.colors.brand.tertiary} !important;
  }
  
  .bg-white {
    background-color: ${(props) => props.theme.colors.background.primary} !important;
  }
  
  .bg-light {
    background-color: ${(props) => props.theme.colors.background.secondary} !important;
  }
  
  .bg-error {
    background-color: ${(props) => props.theme.colors.feedback.error} !important;
  }
  
  .bg-success {
    background-color: ${(props) => props.theme.colors.feedback.success} !important;
  }
  
  /* Font weight utility classes */
  .font-regular {
    font-weight: ${(props) => props.theme.typography.fontWeight.regular} !important;
  }
  
  .font-medium {
    font-weight: ${(props) => props.theme.typography.fontWeight.medium} !important;
  }
  
  .font-semibold {
    font-weight: ${(props) => props.theme.typography.fontWeight.semiBold} !important;
  }
  
  .font-bold {
    font-weight: ${(props) => props.theme.typography.fontWeight.bold} !important;
  }
  
  /* Font size utility classes */
  .text-xs {
    font-size: ${(props) => props.theme.typography.fontSize.xs} !important;
  }
  
  .text-sm {
    font-size: ${(props) => props.theme.typography.fontSize.sm} !important;
  }
  
  .text-md {
    font-size: ${(props) => props.theme.typography.fontSize.md} !important;
  }
  
  .text-lg {
    font-size: ${(props) => props.theme.typography.fontSize.lg} !important;
  }
  
  .text-xl {
    font-size: ${(props) => props.theme.typography.fontSize.xl} !important;
  }
  
  .text-2xl {
    font-size: ${(props) => props.theme.typography.fontSize.xxl} !important;
  }
  
  .text-3xl {
    font-size: ${(props) => props.theme.typography.fontSize.xxxl} !important;
  }
  
  /* Custom Typography Classes */
  .page-main-heading {
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    font-weight: ${(props) => props.theme.typography.fontWeight.regular};
    font-size: ${(props) => props.theme.typography.fontSize.lg};
    line-height: 100%;
    color: #1C1C1C;
  }
  
  .page-sub-heading {
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    font-weight: ${(props) => props.theme.typography.fontWeight.regular};
    font-size: ${(props) => props.theme.typography.fontSize.sm};
    line-height: 100%;
    letter-spacing: 0%;
    color: #7E7E7E;
  }
  
  .section-heading {
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    font-weight: ${(props) => props.theme.typography.fontWeight.regular};
    font-size: ${(props) => props.theme.typography.fontSize.md};
    line-height: 100%;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #1C1C1C;
  }
  
  .section-sub-heading {
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    font-weight: ${(props) => props.theme.typography.fontWeight.medium};
    font-size: ${(props) => props.theme.typography.fontSize.sm};
    line-height: 100%;
    letter-spacing: 0%;
    color: #7E7E7E;
  }
`;
